import React from "react";
import "./Navbar.css";

function Navbar() {
  return (
    <nav className="navbar">
      <div className="logo-section">
        <img src="https://transparency.org.pk/wp-content/uploads/2021/08/NEW_TRANS_LOGO.png" alt="Logo" className="logo" />
        {/* <div className="title">
          <h2>TRANSPARENCY</h2>
          <p>INTERNATIONAL - PAKISTAN</p>
        </div> */}
      </div>

      <ul className="menu">
        <li><a href="https://transparency.org.pk/">HOME</a></li>

        <li className="dropdown">
          <a href="#">WHO WE ARE ▾</a>
          <ul className="dropdown-menu">
            <li><a href="https://transparency.org.pk/our-organiztion/">Our Organization</a></li>
            <li><a href="#">Our Policies</a></li>
            <li><a href="#">Annual Reports</a></li>
            <li><a href="#">Audit Reports</a></li>
          </ul>
        </li>

        <li className="dropdown">
          <a href="#">WHAT WE DO ▾</a>
          <ul className="dropdown-menu">
            <li><a href="#">Our Projects</a></li>
            <li><a href="#">Events / Workshop</a></li>
            <li><a href="#">MOU</a></li>
            <li><a href="#">Procurement</a></li>
            <li><a href="#">Success Story</a></li>
            <li><a href="#">Whistleblower Pakistan</a></li>
          </ul>
        </li>

        <li className="dropdown">
          <a href="#">RESOURCES ▾</a>
          <ul className="dropdown-menu">
            <li><a href="#">Publication</a></li>
            <li><a href="#">Newsletter</a></li>
            <li><a href="#">GDA Tracker</a></li>
            <li><a href="#">CPI</a></li>
            <li><a href="#">NCPS</a></li>
            <li><a href="#">Local Government</a></li>
            <li><a href="#">Youth Fellowship Program</a></li>
            <li><a href="#">Governance Diagnostic Assessment</a></li>
            <li><a href="#">Business Integrity</a></li>
            <li><a href="#">Press Release</a></li>
          </ul>
        </li>

        <li><a href="#">ALAC</a></li>

        <li className="dropdown">
          <a href="#">CONTACT ▾</a>
          <ul className="dropdown-menu">
            <li><a href="#">Contact Form</a></li>
            <li><a href="#">Office Locations</a></li>
          </ul>
        </li>
      </ul>
    </nav>
  );
}

export default Navbar;
